import React from 'react';
import { Calendar } from 'lucide-react';
import { Row, Col, Input, Select, SectionTitle, FormField } from '../../../SharedInputs.jsx';
import { MONTHS } from '../../../../constants.js';

export function SectionIntake({ value, onChange, errors = [] }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  const getFieldError = (fieldName) => {
    return errors.find(error => error.toLowerCase().includes(fieldName.toLowerCase()));
  };

  const currentYear = new Date().getFullYear();
  const availableYears = Array.from({ length: 5 }, (_, i) => currentYear + i);

  return (
    <div>
      <SectionTitle icon={Calendar} step={3}>
        Preferred Intake Date
      </SectionTitle>

      <div style={{
        padding: 16,
        background: '#f8faff',
        borderRadius: 8,
        border: '1px solid #e0e7ff',
        marginBottom: 24
      }}>
        <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>
          Select your preferred study commencement date. Please note that course availability 
          may vary by campus and intake period. Our admissions team will confirm availability 
          and may suggest alternative dates if your preferred intake is full.
        </p>
      </div>

      <Row>
        <Col span={6}>
          <FormField 
            label="Intake Month" 
            required
            error={getFieldError('month')}
          >
            <Select
              required
              value={value.month}
              onChange={(e) => updateField('month', e.target.value)}
              error={!!getFieldError('month')}
            >
              <option value="">Select Month</option>
              {MONTHS.map(month => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </Select>
          </FormField>
        </Col>
        <Col span={6}>
          <FormField 
            label="Intake Year" 
            required
            error={getFieldError('year')}
          >
            <Select
              required
              value={value.year}
              onChange={(e) => updateField('year', e.target.value)}
              error={!!getFieldError('year')}
            >
              <option value="">Select Year</option>
              {availableYears.map(year => (
                <option key={year} value={year.toString()}>
                  {year}
                </option>
              ))}
            </Select>
          </FormField>
        </Col>
      </Row>

      {/* Display selected intake */}
      {value.month && value.year && (
        <div style={{
          marginTop: 20,
          padding: 16,
          background: '#f0fdf4',
          borderRadius: 8,
          border: '1px solid #bbf7d0'
        }}>
          <h4 style={{ margin: '0 0 8px', color: '#065f46' }}>Selected Intake:</h4>
          <p style={{ margin: 0, color: '#047857', fontSize: 16, fontWeight: 600 }}>
            {value.month} {value.year}
          </p>
          <p style={{ margin: '8px 0 0', color: '#059669', fontSize: 12 }}>
            Subject to course availability and visa processing times
          </p>
        </div>
      )}

      {/* Intake Information */}
      <div style={{
        marginTop: 24,
        padding: 16,
        background: '#fffbeb',
        borderRadius: 8,
        border: '1px solid #fed7aa'
      }}>
        <h4 style={{ margin: '0 0 12px', color: '#92400e' }}>Intake Information</h4>
        <ul style={{ margin: 0, paddingLeft: 20, color: '#b45309', fontSize: 14 }}>
          <li style={{ marginBottom: 8 }}>Most courses have multiple intake dates throughout the year</li>
          <li style={{ marginBottom: 8 }}>Popular intakes may fill up quickly - apply early</li>
          <li style={{ marginBottom: 8 }}>Allow sufficient time for visa processing if studying from overseas</li>
          <li>Our admissions team will confirm your intake date after reviewing your application</li>
        </ul>
      </div>
    </div>
  );
}